import { useEffect } from 'react';
import FJConstant from '../constants/FJConstant.js';
import FJEvent from '../store/FJEvent.js';
import FJLocalStore from '../store/FJLocalStore.js';
import FJCodecStore from '@src/store/FJCodecStore.js';
import { FJCommonAction } from '@src/redux/action/FJCommonAction.js';
import { useAppDispatch } from '@src/redux/hooks.js';
import FJDetectStore from '@src/store/FJDetectStore.js';

function useInitProject() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        FJCodecStore.init();
        FJDetectStore.ensureModelsLoaded();
        FJLocalStore.initLanguage();
        dispatch(
            FJCommonAction.initProjectAction(() => {
                if (document.getElementById('app-entry-loading')) {
                    document.getElementById('app-entry-loading').remove();
                }
                if (document.getElementById('app-loading-mask')) {
                    document.getElementById('app-loading-mask').remove();
                }
            }),
        );
    }, []);
    useEffect(() => {
        //更新用户积分（包括header）
        let unSubscribeUpdateCreditsSubscribe = () => {};
        const unSubscribeDiscountSubscribe = () => {};
        // login btn 也使用此事件更新
        if (window.fj && window.fj.event && window.fj.event.subscribe) {
            unSubscribeUpdateCreditsSubscribe = window.fj.event.subscribe('UPDATE_USER_CREDITS', () => {
                dispatch(FJCommonAction.fetchCreditsInfoAction());
                dispatch(FJCommonAction.fetchFreeTimesAction());
            });
        }

        return () => {
            unSubscribeUpdateCreditsSubscribe();
            unSubscribeDiscountSubscribe();
        };
    }, []);
    useEffect(() => {
        //登陆相关事件处理
        const _login = () => {
            dispatch(FJCommonAction.initProjectAction());
        };
        const _loginOut = () => {
            location.reload();
        };
        if (window.fjuser && window.fjuser.addListener) {
            const { login, logout } = window.fjuser.eventType;
            window.fjuser.addListener(login, _login);
            window.fjuser.addListener(logout, _loginOut);
        }
        // 订阅页事件切换团队/用户弹窗
        if (window.fj && window.fj.event && window.fj.event.subscribe) {
            window.fj.event.subscribe(FJConstant.ACCOUNT_CHANGE, () => {
                // dispatch(FJActionModal.accountChangesModalAction());
            });
        }
        FJEvent.subscribe(FJConstant.USER_SPACE_CHANGE, () => {
            // dispatch(FJActionCommon.userSpaceChangeAction(type));
        });
        return () => {
            if (window.fjuser && window.fjuser.addListener) {
                const { login, logout } = window.fjuser.eventType;
                window.fjuser.removeListener(login, _login);
                window.fjuser.removeListener(logout, _loginOut);
            }
        };
    }, []);
}

export default useInitProject;
